// WHERE SOME TILES SIT ON THE BUILDING GRID (owner 2026-11-02: "grid information should show on
// the sign-off view, the request, the print and the timeline, always visible"): the grid lines
// that bound them each way, as a site reads it - "C-H / 2-5". The same rule as the PDF
// (back/utils/signoffRequests.gridSpan). '' when the model has no grid.

/** The grid lines round `keys` (tile keys) on `grid` (the tile view's grid, model units). */
export function gridSpan(lines, grid, keys) {
  if (!grid || !grid.origin || !(lines || []).length || !keys) return "";
  let x0 = Infinity; let x1 = -Infinity; let z0 = Infinity; let z1 = -Infinity;
  for (const key of keys) {
    const m = /^T-(\d+)-(\d+)-(\d+)$/.exec(String(key));
    if (!m) continue;
    const i = Number(m[1]); const j = Number(m[2]);
    x0 = Math.min(x0, grid.origin.x + i * grid.edge); x1 = Math.max(x1, grid.origin.x + (i + 1) * grid.edge);
    z0 = Math.min(z0, grid.origin.z + j * grid.edge); z1 = Math.max(z1, grid.origin.z + (j + 1) * grid.edge);
  }
  if (!Number.isFinite(x0)) return "";
  const across = []; const along = [];
  for (const l of lines) {
    if (!l || !l.label || !l.start || !l.end) continue;
    const dx = Math.abs(l.start[0] - l.end[0]); const dz = Math.abs(l.start[2] - l.end[2]);
    if (dx < dz * 0.05) across.push({ at: (l.start[0] + l.end[0]) / 2, label: l.label });
    else if (dz < dx * 0.05) along.push({ at: (l.start[2] + l.end[2]) / 2, label: l.label });
  }
  const span = (ls, lo, hi) => {
    if (!ls.length) return "";
    const sorted = [...ls].sort((a, b) => a.at - b.at);
    const tol = grid.edge * 1e-3;
    let a = sorted.filter((l) => l.at <= lo + tol).pop() || sorted.find((l) => l.at >= lo - tol);
    let b = sorted.find((l) => l.at >= hi - tol) || sorted[sorted.length - 1];
    if (a.at > b.at) [a, b] = [b, a];
    return a.label === b.label ? a.label : `${a.label}-${b.label}`;
  };
  return [span(across, x0, x1), span(along, z0, z1)].filter(Boolean).join(" / ");
}

/** "Grid lines C-H / 2-5", or what to say when there is none. */
export function gridText(lines, grid, keys) {
  if (!(lines || []).length) return "No building grid in this model";
  const s = gridSpan(lines, grid, keys);
  return s ? `Grid lines ${s}` : "Grid lines -";
}
